import React, { useState, useEffect } from "react";
import "../App.css";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import user from "../assets/user.png";
import MyLoader from "./util/loader";
import MyStorage from "./util/storage";
import Api from "./api/api";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";
import "reactjs-popup/dist/index.css";
import MyPopup from "./util/popup";

const SpecialProgramDetail = () => {
  var history = useHistory();
  const location = useLocation();
  const model = location.state.model;
  let filePath = MyStorage.getFileUrls().SpecialProgram;

  const [tab, setTab] = useState(0);
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);

  const [image, setImage] = useState("");
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");
  const [price, setPrice] = useState("");
  const [inappId, setInappId] = useState("");
  const [expiry, setExpiry] = useState("");
  // const [ages, setAges] = useState([]);
  // const [goals, setGoals] = useState([]);
  const [age, setAge] = useState(""); // id
  const [goal, setGoal] = useState(""); // id
  const [videos, setVideos] = useState([]);
  const [sections, setSections] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [members, setMembers] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setImage(model.image);
    setTitle(model.title);
    setDetail(model.detail);
    setPrice(model.price);
    setInappId(model.inapp_id == null ? "" : model.inapp_id);
    setExpiry(model.non_member_expiry === 0 ? "" : model.non_member_expiry);
    setLoader(true);
    Api.getSpecialProgramDetails(
      model.id,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          const programDetails = response.data;
          const videoLinks = programDetails.videoLinks;
          const sectionLinks = programDetails.sectionLinks;
          const programLinks = programDetails.programLinks;
          setVideos(videoLinks);
          setSections(sectionLinks);
          setPrograms(programLinks);
        }
      },
      (error) => {
        setLoader(false);
      }
    );
    // load filters
    Api.getFilters(
      (response) => {
        for (let i = 0; i < response.ages.length; i++) {
          const age = response.ages[i];
          if (age.id + "" === model.age) {
            setAge(age.title);
          }
        }
        for (let i = 0; i < response.goals.length; i++) {
          const goal = response.goals[i];
          if (goal.id + "" === model.goal) {
            setGoal(goal.title);
          }
        }
      },
      (error) => {
        //
      }
    );
    loadMembers();
  };

  const loadMembers = () => {
    setLoader(true);
    Api.getSpecialProgramMembers(
      model.id,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          setMembers(response.data);
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const deleteProgram = (program) => {
    if (window.confirm("Are you sure you wish to delete this program?")) {
      setLoader(true);
      Api.deleteSpecialProgram(
        program.id,
        (response) => {
          setLoader(false);
          if (response.status === "success") {
            showToast("success", "Program deleted!");
            history.goBack();
          }
        },
        (error) => {
          setLoader(false);
          showToast("error", "Request failed!");
        }
      );
    }
  };

  const getProfilePhoto = (model) => {
    if (
      MyStorage.getFileUrls() == null ||
      model.photo == null ||
      model.photo === ""
    ) {
      return user;
    } else {
      if (model.photo.includes("http")) {
        return model.photo;
      }
      return MyStorage.getFileUrls().User + model.photo;
    }
  };

  const showDetails = () => {
    return (
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <img
          src={filePath + image}
          style={{
            width: 150,
            height: 150,
            marginBottom: 10,
            marginTop: 10,
            objectFit: "contain",
            alignSelf: "center",
            backgroundColor: "#f2f2f2",
          }}
        />
        <div
          style={{
            marginTop: 10,
            padding: 8,
            backgroundColor: "#F2F2F2",
            display: "flex",
            width: "100%",
          }}
        >
          <div style={{ color: "gray", marginRight: 10 }}>Title:</div>
          {title}
        </div>
        <div
          style={{
            padding: 8,
            backgroundColor: "#ffffff",
            display: "flex",
            width: "100%",
          }}
        >
          <div style={{ color: "gray", marginRight: 10 }}>Detail:</div>
          {detail}
        </div>
        <div
          style={{
            padding: 8,
            backgroundColor: "#F2F2F2",
            display: "flex",
            width: "100%",
          }}
        >
          <div style={{ color: "gray", marginRight: 10 }}>Price:</div>
          {price === "0" ? "FREE" : "$" + price}
        </div>
        <div
          style={{
            padding: 8,
            backgroundColor: "#ffffff",
            display: "flex",
            width: "100%",
          }}
        >
          <div style={{ color: "gray", marginRight: 10 }}>
            Apple/Google Product ID:
          </div>
          {inappId}
        </div>
        <div
          style={{
            padding: 8,
            backgroundColor: "#F2F2F2",
            display: "flex",
            width: "100%",
          }}
        >
          <div style={{ color: "gray", marginRight: 10 }}>
            Non-Subscriber Expiry Days:
          </div>
          {expiry}
        </div>
        <div
          style={{
            padding: 8,
            backgroundColor: "#ffffff",
            display: "flex",
            width: "100%",
          }}
        >
          <div style={{ color: "gray", marginRight: 10 }}>Age Range:</div>
          {age}
        </div>
        <div
          style={{
            padding: 8,
            backgroundColor: "#F2F2F2",
            display: "flex",
            width: "100%",
          }}
        >
          <div style={{ color: "gray", marginRight: 10 }}>Goal:</div>
          {goal}
        </div>
        <div style={{ padding: 8, backgroundColor: "#ffffff", width: "100%" }}>
          <div style={{ color: "gray", marginRight: 10 }}>
            Videos ({videos.length}):
          </div>
          {videos.map((item, index) => {
            console.log("video: " + JSON.stringify(item));
            return (
              <div style={{ display: "flex", marginTop: 5 }}>
                <div
                  style={{ alignSelf: "center", fontSize: 14, color: "blue" }}
                  onClick={() => {
                    console.log("click");
                  }}
                >
                  {item.video.title}
                </div>
              </div>
            );
          })}
        </div>
        {/* <div style={{ padding: 8, backgroundColor: '#F2F2F2', width: '100%' }}>
                    <div style={{ color: 'gray', marginRight: 10 }}>Sections ({sections.length}):</div>
                    {sections.map((item, index) => {
                        return (
                            <div
                                style={{ display: 'flex', marginTop: 5 }}>
                                <div
                                    style={{ alignSelf: 'center', fontSize: 14, color: 'blue' }}
                                    onClick={() => {
                                        console.log('click');
                                    }}>
                                    {item.category.title}
                                </div>
                            </div>
                        )
                    })}
                </div> */}
        <div style={{ padding: 8, backgroundColor: "#ffffff", width: "100%" }}>
          <div style={{ color: "gray", marginRight: 10 }}>
            Special Programs ({programs.length}):
          </div>
          {programs.map((item, index) => {
            return (
              <div style={{ display: "flex", marginTop: 5 }}>
                <div
                  style={{ alignSelf: "center", fontSize: 14, color: "blue" }}
                  onClick={() => {
                    console.log("click");
                  }}
                >
                  {item.special_program.title}
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ display: "flex", marginTop: 20, width: "100%" }}>
          <Button
            className="btn-block"
            style={{
              backgroundColor: "red",
              borderWidth: 0,
              width: "100%",
              fontSize: 16,
            }}
            onClick={() => {
              console.log("click");
              deleteProgram(model);
            }}
          >
            Delete
          </Button>
        </div>
      </div>
    );
  };

  const addMembers = (users) => {
    // label, value
    // make comma separated list of user_ids
    let user_ids = "";
    for (let i = 0; i < users.length; i++) {
      const user = users[i];
      user_ids = user_ids + user.value + ",";
    }

    setLoader(true);
    Api.addMembers(
      model.id,
      user_ids,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          loadMembers();
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const removeMember = (user_id) => {
    setLoader(true);
    Api.removeMembers(
      model.id,
      user_id,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          loadMembers();
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const showMembers = () => {
    return (
      <div style={{ width: "100%" }}>
        <MyPopup
          collect="id"
          title={"Select Users"}
          models={MyStorage.getAllUsers()}
          onDone={(users) => {
            console.log("selected: " + JSON.stringify(users));
            addMembers(users);
          }}
          button={
            <Button
              className="btn-block"
              style={{
                backgroundColor: "blue",
                borderWidth: 0,
                width: "100%",
                marginTop: 15,
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
              }}
            >
              Add Member
            </Button>
          }
        />
        <div style={{ fontSize: 14, marginTop: 10 }}>
          Using 'Add Member' button you can add free members to this program or
          add any users who payed you outside the system.
        </div>
        <div
          style={{
            marginTop: 10,
            marginBottom: 10,
            padding: 8,
            backgroundColor: "#F2F2F2",
            display: "flex",
            width: "100%",
          }}
        >
          <div style={{ color: "gray", marginRight: 10 }}>Members:</div>
          {members.length}
        </div>
        {members.map((model, index) => {
          let className =
            index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className={className} style={{ marginTop: 0 }}>
                <div className="projects-item-photo">
                  <img
                    src={getProfilePhoto(model.user)}
                    style={{ padding: 1, width: 70, height: 70 }}
                  />
                </div>
                <div className="projects-item-cat" style={{}}>
                  <div style={{ fontSize: 16 }}>
                    {model.user.fname + " " + model.user.lname}
                  </div>
                  <div style={{ fontSize: 13, color: "blue" }}>
                    {model.type + ": " + model.added_date}
                  </div>
                </div>

                <div
                  className="projects-item-cat"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    className="btn-block btn-submit"
                    style={{ width: 120, fontSize: 16 }}
                    onClick={() => {
                      console.log("click");
                      history.push({
                        pathname: "/user-details",
                        state: { user: model.user },
                      });
                    }}
                  >
                    View Details
                  </Button>
                  <Button
                    style={{
                      width: 100,
                      backgroundColor: "red",
                      marginLeft: 10,
                      fontSize: 16,
                    }}
                    className="btn-block btn-submit"
                    onClick={() => {
                      console.log("click");
                      removeMember(model.user.id);
                    }}
                  >
                    Remove
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>Special Program Details</div>
      </div>
      <div
        style={{
          marginTop: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            width: 600,
            marginTop: 10,
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ display: "flex", width: "100%" }}>
            <button
              className="btn-block"
              style={{
                color: "white",
                fontSize: 14,
                height: 30,
                backgroundColor: tab === 0 ? "black" : "gray",
                borderWidth: 0,
                width: "50%",
                borderBottomLeftRadius: 5,
                borderTopLeftRadius: 5,
              }}
              onClick={() => {
                console.log("click");
                setTab(0);
              }}
            >
              Details
            </button>
            <button
              className="btn-block"
              style={{
                color: "white",
                fontSize: 14,
                height: 30,
                backgroundColor: tab === 1 ? "black" : "gray",
                borderWidth: 0,
                width: "50%",
                borderBottomRightRadius: 5,
                borderTopRightRadius: 5,
              }}
              onClick={() => {
                console.log("click");
                setTab(1);
              }}
            >
              Members
            </button>
          </div>

          {tab === 0 ? showDetails() : showMembers()}
        </div>
      </div>
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default SpecialProgramDetail;
